import { CompanyType } from '../../domain/benefit/companyType'
import { EmploymentStatus } from '../adminDashboard/managePeople/enums/employmentStatus'

const isEmployeeEligible = (employmentStatus: EmploymentStatus, companyTypeId: CompanyType): boolean => {
 return (
    employmentStatus === EmploymentStatus.FullTime ||
    employmentStatus === EmploymentStatus.PartTime ||
    (employmentStatus === EmploymentStatus.Owner && isOwnerEligible(companyTypeId))
  )

}

type ProductClassRequest = {
  id: string
  name: string
  allowedEligibilityStatuses: EmploymentStatus[]
}
export const isEmployeeEligibleForProductClass = (employmentStatus: EmploymentStatus, companyTypeId: CompanyType, productClass: ProductClassRequest): boolean => {

  if(productClass != null && productClass.allowedEligibilityStatuses.length > 0) {
    return productClass.allowedEligibilityStatuses.some((y) => y == employmentStatus)
  }
  else{
  return  isEmployeeEligible(employmentStatus, companyTypeId)
  }
}

const isOwnerEligible = (companyTypeId: CompanyType): boolean => {
  return companyTypeId === CompanyType.CCorpNonProfitOrMunicipality
}

export default isEmployeeEligible
